import { render, staticRenderFns } from "./LoanForeclosureView.vue?vue&type=template&id=53507d90&scoped=true"
import script from "./LoanForeclosureView.vue?vue&type=script&lang=js"
export * from "./LoanForeclosureView.vue?vue&type=script&lang=js"
import style0 from "./LoanForeclosureView.vue?vue&type=style&index=0&id=53507d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53507d90",
  null
  
)

export default component.exports